import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/jobFunctions/scheduleSiteWorkActions'
import { actions as jobNoteActions } from '../../../redux/modules/jobFunctions/jobNoteActions'
import Loader from '../../common/Loader'
import ScheduleSiteWorkDatesView from '../../../components/ScheduleSiteWorkDatesView'
import ScheduleMachinesMenu from '../../../components/ScheduleMachineMenu'
import Notes from '../../../components/notes/Notes'
import _ from 'lodash'

const propTypes = {}

class ScheduleSiteWork extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditing: false
    }

    this.props.getScheduleSiteWorkDates({
      jobId: this.props.jobId
    })

    this.props.getScheduleNote({
      jobId: this.props.jobId
    })
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.shortcutItemId &&
      this.props.scheduleSiteWorkActions.scheduleSiteWorkDates !==
        prevProps.scheduleSiteWorkActions.scheduleSiteWorkDates
    ) {
      this.setState({
        machineIndex: this.props.shortcutItemId,
        arrayIndex: _.findIndex(
          this.props.scheduleSiteWorkActions.scheduleSiteWorkDates.data,
          schedule => schedule.id === this.props.shortcutItemId
        )
      })
      this.props.clearHighlight()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.scheduleSiteWorkActions.scheduleSiteWorkDates !==
      nextProps.scheduleSiteWorkActions.scheduleSiteWorkDates
    ) {
      this.setState({
        machineIndex:
          nextProps.scheduleSiteWorkActions.scheduleSiteWorkDates.data[
            nextProps.scheduleSiteWorkActions.scheduleSiteWorkDates.data.length - 1
          ].id,
        arrayIndex: nextProps.scheduleSiteWorkActions.scheduleSiteWorkDates.data.length - 1
      })
    }
  }

  handleEditDateClick = () => {
    this.setState({
      isEditing: true
    })
  }

  changeMachineIndex = (arrayIndex, index) => {
    this.setState({
      machineIndex: index,
      arrayIndex: arrayIndex
    })
  }

  handleDeleteSchedule = scheduleId => {
    this.props.deleteScheduleSiteWork({
      jobId: this.props.jobId,
      scheduleId: scheduleId
    })
    this.setState({
      machineIndex: 1,
      arrayIndex: 0
    })
  }

  clearFields = () => {
    this.setState({ contentData: null, currentId: 0, isEditing: false })
  }

  // notes things
  handleToggleNoteEditArea = () => {
    if (this.state.currentNote) {
      this.setState({
        currentNote: null,
        currentNoteId: null,
        noteAddEditContainer: true
      })
    } else {
      this.setState({
        noteAddEditContainer: !this.state.noteAddEditContainer
      })
    }
  }

  createNote = params => {
    this.props.createScheduleNote({
      content: params,
      userId: this.props.user.userId,
      jobId: this.props.jobId
    })

    this.handleToggleNoteEditArea()
  }

  updateNote = params => {
    this.props.editScheduleNote({
      content: params,
      noteId: this.state.currentNoteId,
      jobId: this.props.jobId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  deleteNote = () => {
    this.props.deleteScheduleNote({
      noteId: this.state.currentNoteId,
      jobId: this.props.jobId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null,
      noteAddEditContainer: false
    })
  }

  handleRowNoteClick = row => {
    this.setState({
      noteAddEditContainer: true,
      currentNote: row,
      currentNoteId: row.id
    })
  }

  render() {
    const { scheduleSiteWorkDates } = this.props.scheduleSiteWorkActions

    if (!scheduleSiteWorkDates) {
      return <Loader />
    }

    return (
      <div>
        <div className="jobsBar">
          Schedule Site Work
          {!this.state.isEditing && (
            <div className="jobsBarAdd" onClick={() => this.handleEditDateClick()}>
              <i className="fa fa-pencil-square" aria-hidden="true" />
              &nbsp;<div className="addJobLabel">EDIT Dates</div>
            </div>
          )}
        </div>
        <ScheduleMachinesMenu
          data={scheduleSiteWorkDates.data}
          currentIndex={this.state.arrayIndex}
          changeMachineIndex={this.changeMachineIndex}
          addMachine={this.props.addScheduleSiteWorkDate}
          jobId={this.props.jobId}
          userId={this.props.user.userId}
        />
        {scheduleSiteWorkDates.data && (
          <ScheduleSiteWorkDatesView
            data={scheduleSiteWorkDates.data[this.state.arrayIndex]}
            machineIndex={this.state.machineIndex}
            isEditing={this.state.isEditing}
            updateSiteWorkDates={this.props.updateSiteWorkDates}
            deleteSchedule={this.handleDeleteSchedule}
            updateNotes={this.props.updateNotes}
            jobId={this.props.jobId}
            clearFields={this.clearFields}
            clearHighlight={this.props.clearHighlight}
            scheduleSiteWorkType={this.props.scheduleSiteWorkType}
            userId={this.props.user.userId}
          />
        )}
        <div className="row p-5">
          <div className="col-12">
            <Notes
              // notes props
              currentNote={this.state.currentNote}
              currentNoteId={this.state.currentNoteId}
              notes={
                this.props.jobNoteActions.scheduleNotes &&
                this.props.jobNoteActions.scheduleNotes.data
              }
              handleToggleNoteEditArea={this.handleToggleNoteEditArea}
              noteAddEditContainer={this.state.noteAddEditContainer}
              createNote={this.createNote}
              handleRowNoteClick={this.handleRowNoteClick}
              updateNote={this.updateNote}
              userId={this.props.user.userId}
              deleteNote={this.deleteNote}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ scheduleSiteWorkActions, jobNoteActions }, ownProps) => ({
  scheduleSiteWorkActions,
  jobNoteActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, jobNoteActions), dispatch)
})

ScheduleSiteWork.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScheduleSiteWork))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/ScheduleSiteWork.js